import { PreviewConstants } from 'src/constants';
import { PreviewState, StateConfig } from 'src/types';

const PREVIEW_SPECS = {
  dimensions: {
    width: 1920,
    height: 1080,
  },
  states: {
    [PreviewConstants.PREVIEW_LABELS.SELECTED]: {
      containerOffset: 0,
      logo: { x: 104, y: 270 },
      background: { x: -447, y: 0 },
      overlay: { x: 0, y: 0 },
    },
    [PreviewConstants.PREVIEW_LABELS.UNSELECTED]: {
      containerOffset: -33,
      logo: { x: 104, y: 56 },
      background: { x: 0, y: 0 },
      overlay: { x: 0, y: 0 },
    },
  } as Record<PreviewState, StateConfig>,
} as const;

const LOGO_DIMENSIONS = {
  width: 640,
  height: 260,
} as const;

const BACKGROUND_UPSCALED_DIMENSIONS = {
  width: 2410,
  height: 904,
} as const;

const CANVAS_SPECS = {
  backgroundColor: '#000000',
  imageFormat: 'image/jpeg',
  imageQuality: 0.95,
  position: {
    x: 0,
    y: 0,
  },
} as const;

export { PREVIEW_SPECS, LOGO_DIMENSIONS, CANVAS_SPECS, BACKGROUND_UPSCALED_DIMENSIONS };
